module.exports = __webpack_public_path__ + "img/shop-1_720x446.6689185d.jpg";